import styled from 'styled-components';

const Field = styled.div`
    margin-bottom: 25px;
    /* &:last-of-type {
        margin-bottom: 0;
    } */
`;

export default Field;
